import {
	SET_FORM_STATE,
	SET_FORM_STATE_CLUSTER
} from '../actions/RanReportRFActions';

const initialState = {
	formState:
	{
		isValid: false,
		values: {},
		touched: {},
		errors: {}
	},
	formStateCluster:
	{
		isValid: false,
		values: {},
		aggregation: '',
		touched: {},
		errors: {}
	},
};

const ranReportRFReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							formState: action.formState
						};
					}
					case SET_FORM_STATE_CLUSTER: {
						return {
							...state,
							formStateCluster: action.formStateCluster
						};
					}
					default: {
						return state;
					}
	}
};

export default ranReportRFReducer;
